import React, { useEffect, useMemo } from 'react';
import FuzzySearch from 'fuzzy-search';
import { AutocompleteSelectProps } from './types';
import AutocompleteInput from '../AutocompleteInput';

const AutocompleteSelect: React.FC<AutocompleteSelectProps> = ({
    value,
    onChange,
    isDisabled,
    onBlur,
    selectOptions,
    ...toPass
}) => {
    const selectedOption = selectOptions.find((option) => option.value === value);
    const [textInputValue, setTextInputValue] = React.useState(selectedOption?.label || '');
    const sortedSelectOptions = useMemo(() => {
        return selectOptions.sort((a, b) => a.label.localeCompare(b.label));
    }, [selectOptions]);
    useEffect(() => {
        setTextInputValue(selectedOption?.label || '');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);
    const searchFilteredOptions = useMemo(() => {
        if (!textInputValue) {
            return sortedSelectOptions;
        }
        const searcher = new FuzzySearch(sortedSelectOptions, ['label'], {
            caseSensitive: false,
            sort: true,
        });
        return searcher.search(textInputValue);
    }, [textInputValue, sortedSelectOptions]);

    return (
        <AutocompleteInput
            filteredItems={searchFilteredOptions}
            displayExtractor={(item) => item.label}
            keyExtractor={(item) => item.value}
            isLoadingItems={false}
            onChange={(option) => onChange(option?.value || null)}
            textValue={textInputValue}
            textOnChange={setTextInputValue}
            isDisabled={isDisabled}
            value={selectedOption || null}
            onBlur={onBlur}
            {...toPass}
        />
    );
};

export default React.memo(AutocompleteSelect);
